export default "__VITE_ASSET__BGHkDGjh__"